import React from 'react'
import './header.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import coin from '../../assets/coin.png'
const Header = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    swipeToSlide:true,
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          swipeToSlide:true,
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          swipeToSlide:true,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 470,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
        }
      }
    ]
  };
  return (
    <div className='header section__padding'>
      <div>
        
        <div className='shake-vertical'>
          <img src={coin} alt="" style={{visibility:'hidden'}}/>
          <div className='App-headers'>
            <div id="background" className="clipClear" ></div>
            <div id="clip3" className="clipClear"></div>
            <div id="clip4" className="clipClear"></div>
            <div id="clipa" className="clipClear"></div>
            <div id="clip1" className="clipClear"></div>
            <div id="clip2" className="clipClear"></div>
            <div id="clipb" className="clipClear"></div>
          </div>  
          {/* <div className='App-headers'>
            <div id="background" className="clip" ></div>
            <div id="clip3" className="clip"></div>
            <div id="clip4" className="clip"></div>
            <div id="clipa" className="clip"></div>
            <div id="clip1" className="clip"></div>
            <div id="clip2" className="clip"></div>
            <div id="clipb" className="clip"></div>
          </div>   */}
        </div>
        
      </div>
      
    </div>
  )
}

export default Header
